<mat-toolbar class="topbar">

  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex d-md-none justify-content-center" [class.instructor-hide-mobile]="isInstructorRoute">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- commenting the notification badge. -->
  <!-- <button mat-icon-button aria-label="Notifications">
    <i-tabler class="d-flex" name="bell" matBadge="1" matBadgeColor="primary"></i-tabler>
  </button> -->


  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img [src]="authService.userSig()?.image | filePath" class="rounded-circle object-cover" width="25" />
  </button>
  <mat-menu #profilemenu="matMenu" class="cardWithShadow">
    <a [routerLink]="['/profile/' + authService.userSig()?.id]" mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>My
      Profile
    </a>
    <a [routerLink]="['/school/profile/' + authService.userSig()?.schoolId]" mat-menu-item *ngIf="isSchool">
      <mat-icon class="d-flex align-items-center"><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>
      School Profile
    </a>

    <div class="p-x-12 m-t-12">
      <button mat-stroked-button color="primary" class="w-100" (click)="onLogout()">Logout</button>
    </div>
  </mat-menu>
</mat-toolbar>